import React from "react";
import { withTranslation } from "react-i18next";
import { HiOutlineExclamationTriangle } from "react-icons/hi2";
import Button from "../ui/Button";

// Contains a crashed page so the shell and navigation keep working. Resets
// when the route changes (resetKey).
class RouteErrorBoundaryBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(previousProps) {
    if (previousProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "test") {
      // eslint-disable-next-line no-console
      console.error("Admin page crashed", error, info?.componentStack);
    }
  }

  render() {
    const { t, children } = this.props;
    if (!this.state.error) {
      return children;
    }
    return (
      <div role="alert" className="mx-auto flex max-w-lg flex-col items-center px-4 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-rose-50 text-rose-600">
          <HiOutlineExclamationTriangle size={28} aria-hidden="true" />
        </span>
        <h1 className="mt-5 text-xl font-semibold text-slate-900">{t("shell.pageLoadFailed")}</h1>
        <p className="mt-2 text-sm leading-6 text-slate-500">{t("shell.pageLoadFailedHint")}</p>
        <div className="mt-6 flex gap-2">
          <Button variant="secondary" onClick={() => window.history.back()}>
            {t("common.back")}
          </Button>
          <Button onClick={() => window.location.reload()}>{t("shell.reload")}</Button>
        </div>
      </div>
    );
  }
}

const RouteErrorBoundary = withTranslation()(RouteErrorBoundaryBase);

export default RouteErrorBoundary;
